<!--
 * @Author: caoyingming 1046659469@qq.com
 * @Date: 2022-08-22 09:33:04
 * @LastEditors: caoyingming 1046659469@qq.com
 * @LastEditTime: 2022-08-23 17:13:57
 * @FilePath: /genetron-web/genetron-h5/src/components/template/reportIndex825/variationTest.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <div class="hl-info" @click="detail('variationTest')">
    变异相关临床试验
    <i class="iconfont icon-right_medium"></i>
  </div>
</template>
<script>
import isiOS from "@/utils/iosAn";
export default {
  props: {
    isShowData: {
      type: String,
    },
    templateId: {
      type: String,
    },
  },
  data() {
    return {
      inAnimation: false,
    };
  },
  methods: {
    detail(name) {
      if (this.$route.query.userAgent == "wxWeb") {
        wx.miniProgram.navigateTo({
          url: "/packageWebView/pages/variation-test/variation-test",
        });
      } else if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({ name: name });
      } else {
        window.android.JSCallNative(JSON.stringify({ name: name, type: "" }));
      }
    },
  },
};
</script>
<style lang="less" scoped>
@keyframes bgSize {
  from {
    background: rgba(0, 0, 0, 0)
  }
  to {
    background: rgba(0, 0, 0, 0.05)
  }
}

.newColor {
  animation: bgSize 0.5s ease-in
  // background: rgba(0, 0, 0, 0.05) !important;
}
.hl-info {
  height: 70px;
  font-size: 18PX;
  padding: 0 24px;
  font-weight: 500;
  color: #2f354d;
  line-height: 70px;
  background: @background_color;
  border-radius: 10px;
  margin-bottom: 20px;
  i {
    float: right;
  }
}
.hl-info:active{
  background: rgba(0, 0, 0, 0.05);
  transition: background 0.6s;
}
</style>
